import { NgModule } from '@angular/core';
import { DateTimeInputComponent } from './date-time-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import {ExtendedModule, FlexModule} from '@ngbracket/ngx-layout';
import { MatInputModule } from '@angular/material/input';
import { DirectivesModule } from '@shared/directives/directives.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { SharedModule } from '@shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        CommonModule,
        MatFormFieldModule,
        FlexModule,
        MatInputModule,
        DirectivesModule,
        MatDatepickerModule,
        MatSelectModule,
        SharedModule,
        MatButtonModule,
        MatTooltipModule,
        ExtendedModule,
        MatAutocompleteModule
    ],
    declarations: [DateTimeInputComponent],
    exports: [DateTimeInputComponent]
})
export class DateTimeInputModule {

}
